import { Link } from 'react-router-dom';
import { getFeaturedArticles } from '@/mocks/lore';

export default function HotArticles() {
  const featured = getFeaturedArticles();
  const [first, ...rest] = featured;

  return (
    <section id="hot" className="border-y border-background-200 bg-background-100 py-16 md:py-20">
      <div className="mx-auto max-w-6xl px-4 md:px-6">
        <div className="flex items-end justify-between">
          <div>
            <span className="inline-flex items-center gap-2 rounded-full bg-primary-100 px-4 py-1.5 text-xs font-medium text-primary-800">
              <i className="ri-fire-line text-sm" aria-hidden="true"></i>
              热门解读
            </span>
            <h2 className="mt-4 text-2xl leading-relaxed text-foreground-950 md:text-3xl">被最多读者收藏的设定文章</h2>
          </div>
          <Link to="/lore" className="hidden items-center gap-1 whitespace-nowrap text-sm text-primary-700 transition-colors hover:text-primary-800 sm:inline-flex">
            查看全部
            <i className="ri-arrow-right-line text-sm" aria-hidden="true"></i>
          </Link>
        </div>

        <div className="mt-9 grid gap-6 lg:grid-cols-3">
          <Link
            to={`/lore/${first.slug}`}
            className="group relative flex flex-col justify-end overflow-hidden rounded-lg lg:row-span-2"
          >
            <img
              src={first.cover}
              alt={first.coverAlt}
              className="absolute inset-0 h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/75 via-black/30 to-transparent"></div>
            <div className="relative p-6">
              <span className="inline-block whitespace-nowrap rounded-full bg-accent-500 px-3 py-1 text-xs text-background-50">
                {first.tag}
              </span>
              <h3 className="mt-4 text-xl font-semibold leading-snug text-background-50 md:text-2xl">{first.title}</h3>
              <p className="mt-3 text-sm leading-relaxed text-background-100/90">{first.excerpt}</p>
              <span className="mt-5 inline-flex items-center gap-2 text-sm text-background-50">
                立即阅读
                <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1" aria-hidden="true"></i>
              </span>
            </div>
          </Link>

          {rest.map((a) => (
            <Link
              key={a.slug}
              to={`/lore/${a.slug}`}
              className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-200"
            >
              <div className="h-44 overflow-hidden">
                <img
                  src={a.cover}
                  alt={a.coverAlt}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="flex flex-1 flex-col p-5">
                <div className="flex items-center gap-2">
                  <span className="rounded-full bg-secondary-100 px-3 py-0.5 text-xs text-secondary-900">{a.category}</span>
                  <span className="text-xs text-foreground-500">{a.readTime}</span>
                </div>
                <h3 className="mt-3 text-base font-semibold leading-snug text-foreground-950 group-hover:text-primary-700">
                  {a.title}
                </h3>
                <p className="mt-2 line-clamp-2 text-sm leading-relaxed text-foreground-600">{a.excerpt}</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}